import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Heading,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";
import { useQuery, useQueryClient } from "react-query";
import { Link, useNavigate, useParams } from "react-router-dom";
import http from "../../../core/http";
import { getPartnerReadingOrder } from "../../../services/partnerApi";
import Spinner from "../../../shared/components/Spinner";
import { Card } from "../../auth/components/Login/Card";
import PartnerReadingOrderForm from "../components/PartnerReadingOrderForm";

function PartnerReadingOrderUpdate() {
  const navigate = useNavigate();
  const { id } = useParams();
  const queryClient = useQueryClient();
  const readingOrderId = id;
  const toast = useToast();
  const { data, isLoading, isError, isSuccess } = useQuery(
    ["readingOrder", readingOrderId],
    () => getPartnerReadingOrder(readingOrderId),
    {
      refetchOnWindowFocus: false,
    }
  );

  // Handle form submit
  async function handleSubmit(values) {
    const formData = new FormData();
    formData.append("title", values.title);
    formData.append("description", values.description);
    formData.append("franchise", values.franchise);
    formData.append("order", values.order);
    formData.append("published", values.published);
    formData.append("from_year", values.fromYear);
    formData.append("to_year", values.toYear);
    formData.append("is_ongoing", values.isOngoing);
    if (values.thumbnail) {
      formData.append("thumbnail", values.thumbnail);
    }

    try {
      await http.post(
        `/v1/partner/reading-orders/${readingOrderId}/update`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast({
        title: "Reading order updated.",
        description: "Your reading order information has been updated.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });

      queryClient.invalidateQueries(["readingOrder", readingOrderId]);

      navigate("/partnership/reading-orders/all");

      // handle success
    } catch (error) {
      console.error(error);
      // handle error
      toast({
        title: "Error occured",
        description: error.message,
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    }
  }

  return (
    <Box
      bg={useColorModeValue("gray.50", "inherit")}
      minH="100vh"
      py="12"
      px={{ base: "4", lg: "8" }}
    >
      <Box maxW="xl" mx="auto">
        <Breadcrumb mb="3">
          <BreadcrumbItem>
            <BreadcrumbLink as={Link} to="/partnership/reading-orders/all">
              Reading Orders
            </BreadcrumbLink>
          </BreadcrumbItem>

          <BreadcrumbItem isCurrentPage>
            <BreadcrumbLink>Update: {data?.data?.title}</BreadcrumbLink>
          </BreadcrumbItem>
        </Breadcrumb>

        <Card>
          {isLoading && <Spinner />}
          {isError && <p>Error</p>}
          {isSuccess && (
            <>
              <Heading as="h2" mb="6">
                Update: {data.data.title}
              </Heading>
              <PartnerReadingOrderForm
                readingOrder={data.data}
                handleSubmit={handleSubmit}
              />
            </>
          )}
        </Card>
      </Box>
    </Box>
  );
}

export default PartnerReadingOrderUpdate;
